'use client';

import { FC } from 'react';

import { useContentfulLiveUpdates } from '@contentful/live-preview/react';

import { PublicWebPlans } from '@telialt/core-plans/src/components/Plans/PublicWebPlans';

import { BlockWidgetType } from '../../models/Content';
import {
    isBlockWidgetTypeCoverageMap,
    isBlockWidgetTypeExcavationPermit,
    isBlockWidgetTypeFeedbackForm,
    isBlockWidgetTypePlansList,
    isBlockWidgetTypeSpeedTest,
} from './model';
import { transformBlockWidget } from './transformers';
import { CoverageMap } from './widgets/CoverageMap/CoverageMap';
import { ExcavationPermit } from './widgets/ExcavationPermit/ExcavationPermit';
import { FeedbackForm } from './widgets/FeedbackForm/components/FeedbackForm';
import { SpeedTest } from './widgets/SpeedTest/SpeedTest';

type Props = {
    contentItem: BlockWidgetType;
    searchParams?: { [key: string]: string | undefined };
};

export const BlockWidgetView: FC<Props> = ({ contentItem: initialContentItem, searchParams }) => {
    const contentItem = useContentfulLiveUpdates(initialContentItem);
    const blockWidget = transformBlockWidget(contentItem);

    if (isBlockWidgetTypeCoverageMap(blockWidget)) {
        return <CoverageMap />;
    }

    if (isBlockWidgetTypeFeedbackForm(blockWidget)) {
        return <FeedbackForm />;
    }

    if (isBlockWidgetTypePlansList(blockWidget)) {
        const configuration = blockWidget.configuration;

        return <PublicWebPlans {...configuration} searchParams={searchParams} />;
    }

    if (isBlockWidgetTypeSpeedTest(blockWidget)) {
        return <SpeedTest />;
    }

    if (isBlockWidgetTypeExcavationPermit(blockWidget)) {
        return <ExcavationPermit />;
    }

    return null;
};
